import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../lib/apiClient";

export interface Restaurant {
  id: string;
  name: string;
}

export function useRestaurants() {
  return useQuery({
    queryKey: ["restaurants"],
    queryFn: () => apiClient<Restaurant[]>("/restaurants"),
  });
}
